import debounce from 'lodash/debounce';
import moment from '../../../modules/moment';
import cloneDeep from 'lodash/cloneDeep';
import queryString from 'query-string';
import merge from 'lodash/merge';
import SpaceRepository from '../../../repositories/SpaceRepository';
import { storeQueryString } from '../../query';
import { getViewData } from '../../../modules/view-data';

export default {
    /**
     * Query the search API endpoint with the current
     * search parameters, and update the url
     * parameters with the current search
     *
     * @param context
     * @param searchData
     */
    query: debounce((context, searchData = {}) => {
        if (context.state.searching) {
            return;
        }

        context.commit('setSearching', true);

        storeQueryString(context.state.data);

        const data = merge(cloneDeep(context.state.data), {
            offset: 0,
            with: 'description',
            source: getViewData('partner'),
        });

        // Remove non-TZ'd dates and times
        delete data.start_date;
        delete data.end_date;
        delete data.start_time;
        delete data.end_time;

        const start = new moment(`${ context.state.data.start_date } ${ context.state.data.start_time }`, 'DD-MM-YYYY HH:mm');

        data.start = start.format();

        if (context.state.data.rental === 'short') {
            const end = new moment(`${ context.state.data.end_date } ${ context.state.data.end_time }`, 'DD-MM-YYYY HH:mm');
            data.end = end.format();

            // If short term booking and date range
            // is greater than the soft day limit we'll
            // show the warning modal
            if (end.diff(start, 'days') > 30) {
                window.bus.$emit('showExceedsDayLimitModal');
            }
        }

        if (searchData.lat) {
            data.lat = searchData.lat;
        }

        if (searchData.lng) {
            data.lng = searchData.lng;
        }

        return SpaceRepository
            .query(data)
            .then((response) => {
                context.commit('setCurrentSearch', cloneDeep(context.state.data));
                context.commit('addResults', {
                    results: response.data.data,
                    dragged: searchData.dragged,
                });
                context.commit('setSearchMeta', response.data.meta);
                context.commit('setSearching', false);

                // If the search returned zero results we'll
                // show the user a modal with the option of
                // signing up for alerts
                // This is done only once.
                if (!response.data.data.length && !context.state.noSpacesFoundModalShown) {
                    window.bus.$emit('showNoSpacesFoundModal');
                    context.commit('setNoSpacesFoundModalShown', true);
                }
            }).catch(() => {
                context.commit('setSearching', false);
            });
    }, 100),
};
